import { Button } from '@/components/elements/forms/buttons';
import { classnames } from '@/helpers';
import { _t } from '@/locale/i18n';

type Props = {
  ctaLabel: string;
  onCtaClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onCloseClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  position?: 'fixed' | 'static' | 'sticky';
  withShadow?: boolean;
  className?: string;
  variant?: 'primary' | 'secondary';
};

export const ModalFooter = ({
  ctaLabel,
  onCtaClick,
  onCloseClick,
  position = 'fixed',
  withShadow = true,
  className,
}: Props) => {
  return (
    <footer
      className={classnames(
        'bottom-0 flex h-16 w-full bg-white px-4 py-2',
        {
          relative: position === 'static',
          'z-9999 fixed': position === 'fixed',
          'z-9999 sticky': position === 'sticky',
          shadow: withShadow,
        },
        className,
      )}>
      <div className="mx-auto flex w-full max-w-screen-md items-center justify-between">
        {onCloseClick ? (
          <Button inline size={'sm'} variant={'link'} onClick={onCloseClick}>
            {_t('abort')}
          </Button>
        ) : (
          <span />
        )}
        {onCtaClick && ctaLabel ? (
          <Button variant={'primary'} onClick={onCtaClick}>
            {ctaLabel}
          </Button>
        ) : (
          <span />
        )}
      </div>
    </footer>
  );
};

export default ModalFooter;
